export default __webpack_public_path__ + "static/es_high_perf_asia_pac_spring.png";